import { Component } from "@angular/core";
import { LoadingController, Platform, ToastController } from "@ionic/angular";
import { BaseComponent } from "../../base.component";
import { Router } from "@angular/router";
import { clearStorage, getAccountId, getToken } from "../../service/base.service";
import { UsuarioService } from "src/app/shared/service/perfil/usuario.service";
import { Usuario } from "src/app/shared/model/perfil/usuario.model";
import { IndicacaoService } from "src/app/shared/service/indicacao/indicacao.service";
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { environment } from "src/environments/environment";
import { Device } from '@awesome-cordova-plugins/device/ngx';

@Component({
  selector: 'cmp-painel-minhas-indicacoes',
  templateUrl: './painel-minhas-indicacoes.component.html',
  styleUrls: [
    './painel-minhas-indicacoes.component.scss',
    `../../../../themes/xpory/css/component/indicacoes/painel-minhas-indicacoes.component.scss`,
    `../../../../themes/xpory-futebol/css/component/indicacoes/painel-minhas-indicacoes.component.scss`,
    `../../../../themes/fcj-barter/css/component/indicacoes/painel-minhas-indicacoes.component.scss`,
  ]
})
export class PainelMinhasIndicacoesComponent extends BaseComponent {
  theme = environment.theme_name;
  usuario: Usuario;
  email: string;

  constructor(
    public router: Router,
    public toastController: ToastController, 
    public loadingController: LoadingController,
    public device: Device,
    private usuarioService: UsuarioService,
    private service: IndicacaoService,
    private share: SocialSharing,
    private clipboard: Clipboard){
    super(router, toastController, loadingController);
  }

  ngOnInit(): void {
    this.carregaUsuario();
  }

  carregaUsuario(){
    var token = getToken();
    var accountId = getAccountId();
    this.usuarioService.get(token, accountId).then((resultado: any) =>{
      this.usuario = resultado.entity as Usuario;
    }).catch((ex) =>{
      
    });
  }

  onEmail(){
    if(!this.email || this.email === ''){
      this.message('Informe um e-mail para a indicação!');
      return;
    }

    this.service.indicar(this.email).then((resultado) =>{
      this.message(resultado.msg);
    })
  }

  onWhatsapp(){
    if (this.isWeb()) {
      
    }
    this.share.shareViaWhatsApp(`Você conhece a ${this.label.website}? É uma plataforma de permutas multilaterais onde você anuncia seus produtos e/ou serviços e aumenta seu poder de compra recebendo tudo em X$! Cadastre-se por este link e ganhe crédito de comissão para uso na plataforma após ativação de sua primeira oferta. https://sandbox.xpory.com.br/transferir/${this.usuario.codeIndication}`)
  }

  onFacebook(){
    console.log(`https://xpory.andre.sampa.br/transferir/${this.usuario.codeIndication}`);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=https://xpory.com/transferir/${this.usuario.codeIndication}`, '_blank');
  }

  onCopiar(){
    if(this.isWeb()){
      navigator.clipboard.writeText(this.usuario.codeIndication).then(() => {
        this.message('Código copiado com sucesso!');
      }).catch(() => {
        this.message('Erro ao copiar código');
      });
    }else{
      this.clipboard.copy(this.usuario.codeIndication);
    }
  }
}